export const namespaced = true;

export const state = {
  messages: [],
};

import {
  getPersonalOfficeMessages,
  setMessageRead,
} from "@/services/officeMessages";

export const mutations = {
  SET(state, data) {
    state.messages = data;
  },
  DELETE(state, id) {
    state.messages = state.messages.filter((m) => m.id !== id);
  },
};
export const actions = {
  getMessages({ commit }, lang) {
    getPersonalOfficeMessages(lang).then((res) => {
      commit("SET", res);
    });
  },
  removeMessage({ commit }, msgId) {
    commit("DELETE", msgId);
    setMessageRead(msgId);
  },
};

export const getters = {
  getMessages(state) {
    return state.messages;
  },
};
